import React, { Component } from 'react'
import request from "../../lib/requester";
import _, { toNumber } from "lodash";
import { Loader } from "react-overlay-loader";
import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from 'moment';

class MassUploadBupot extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fileRequired: {
        filename: '',
        path: ''
      },
      dataTable: [],
      lovPrincipal: [],
      containerFile: [],
      selectedOrgId: '',
      selectedOrgInitial: '',
      success: '',
      error: [],
      is_submitted: false,
      user: JSON.parse(window.localStorage.getItem('is_user'))
    }
  }

  componentDidMount = () => {
    this.getPrincipal()
  }

  getPrincipal = () => {
    let url = "/api/traces/v1/general/list-principal";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovPrincipal: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i class="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  removeFile = () => {
    let { fileRequired } = this.state
    fileRequired.filename = ''
    fileRequired.path = ''
    this.setState(fileRequired)
  }

  renderFileUpload = () => {
    return (
      <div className="row">
        <div className="col-md-3">
          <input type="file" className="form-control" id="upload-program-file" onChange={this.handleUploadSingle.bind(this)} />
        </div>
        <div className="col-md-3">
          <select className="form-control" value={this.state.user.org_initial} disabled={true} name="principal" onChange={this.handleChangePrincipal.bind(this)}>
            <option value="">- Select Principal -</option>
            {
              this.state.lovPrincipal.map((item, index) => (
                <option value={item.org_initial}>{item.org_name}</option>
              ))
            }
          </select>
        </div>
        <div className="col-md-3">
          <button className="btn btn-primary btn-block" type="button" onClick={this.handleSubmit.bind(this)} ><i className="fa fa-save" /> Submit</button>
        </div>
        <div className="col-md-3">
          <button className="btn btn-primary btn-warning btn-block" type="button"
            onClick={() => {
              this.setState({ dataTable: [] })
              document.getElementById('upload-program-file').value = null
            }} ><i className="fa fa-undo" /> Reset</button>
        </div>
      </div>
    )
  }

  renderFormUpload = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              {this.renderFileUpload()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  validationForm = () => {
    let error = []
    let { potong_pajak, fileRequired } = this.state
    if (fileRequired.filename.length === 0) {
      error.push('File is required')
    }
    if (error.length > 0) {
      this.setState({ error: error })
      return false
    } else {
      return true
    }
  }

  handleSubmit = () => {
    if (this.state.dataTable.length === 0) {
      alert('No data found')
      return false
    }

    if (window.confirm('Confirm submit all these data?')) {
      let url = '/api/traces/v1/document/bulk-bupot'
      let param = {
        data: this.state.dataTable,
        org_id: this.state.user.org_id,
        user_id: this.state.user.user_id,
        org_initial: this.state.user.org_initial
      }
      this.setState({ loading: true })
      request.postTraces(url, param, {
        success: function (response) {
          this.setState({ loading: false, success: 'All data has been submitted' })
          window.scrollTo(0, 0)

          window.setTimeout(() => {
            document.getElementById('home-tab').classList.remove('active');
            document.getElementById('profile-tab').classList.add('active');

            document.getElementById('home').classList.remove('show', 'active')
            document.getElementById('profile').classList.add('active', 'show')
          }, 3000)
        }.bind(this),
        error: function (e) {
          this.setState({ loading: false, error: [e.response.data.message || 'Failed submit program'] })
          window.scrollTo(0, 0)
        }.bind(this)
      })
    }
  }

  handleInputChange = (e) => {
    let name = e.target.name
    let value = e.target.value

    this.setState({ [name]: value })
  }

  handleUploadSingle = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files[0];
    // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = ["xlsx", "xls"];
    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);
    this.setState({ loading: true });
    request.postnobodyCHD("/api/traces_chd/v1/util/upload-file", data, {
      success: function (response) {
        let data = response.data;
        let { fileRequired } = this.state;
        fileRequired.filename = data.filename;
        fileRequired.path = data.fullurl;
        this.setState(fileRequired);

        // Read Files
        request.postCHD('/api/traces_chd/v1/arman/read-bupot', { files: fileRequired }, {
          success: function (response) {
            let { data } = response.data
            this.setState({ loading: false, dataTable: data });
          }.bind(this),
          error: function (e) {
            this.setState({ loading: false });
          }.bind(this)
        })
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
        console.log(e.message)
      }.bind(this),
    });
  };

  renderTable = () => {
    if (this.state.dataTable.length > 0) {
      const data = {
        columns: [
          {
            Header: "Claim Number",
            accessor: "claim_number",
            filterable: false,
          },
          {
            Header: "Filename",
            accessor: "filename",
            filterable: false,
          },
        ],
        rows: this.state.dataTable,
      };
      return (
        <ReactTable
          className="fullWidth"
          data={data.rows}
          columns={data.columns}
          defaultPageSize={10}
          defaultFilterMethod={(filter, row, column) => {
            let columnes = row[filter.id];
            return columnes
              ? columnes.toLowerCase().includes(filter.value.toLowerCase())
              : "";
          }}
        />
      );
    }
  }

  handleChangePrincipal = (e) => {
    let value = e.target.value
    // let find = _.find(this.state.lovPrincipal, (o) => {
    //   return parseInt(o.org_id) === parseInt(value)
    // })

    // let org_initial = find ? find.org_initial : ''
    // this.setState({ selectedOrgId: value, selectedOrgInitial: org_initial })
  }

  renderFormUploadPDF = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="alert alert-warning">
                <ul>
                  <li><i className="fa fa-exclamation-triangle" /> To multiple upload use CTRL + Click</li>
                  <li><i className="fa fa-exclamation-triangle" /> Allowed file extension: PDF</li>
                </ul>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <input type="file" className="form-control" multiple name="imagesArray" accept=".pdf" onChange={this.handleUploadMultiple.bind(this)} />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-3">
                  <button type="button" className="btn btn-success btn-block" onClick={this.handleUploadSKP.bind(this)}><i className="fa fa-upload" /> Upload</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleUploadMultiple = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files;
    this.setState({ containerFile: files })
  }

  handleUploadSKP = () => {
    const data = new FormData();
    let { containerFile } = this.state

    for (const key of Object.keys(containerFile)) {
      data.append('myFile', containerFile[key])
    }

    this.setState({ loading: true });
    request.postnobodyTraces("/api/traces/v1/general/upload-file-multi", data, {
      success: function (response) {
        let data = response.data;
        this.setState({ loading: false, success: 'All files has been uploaded' })
        window.scrollTo(0, 0)
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false, error: ['Failed to upload SKP'] });
        console.log(e.message)
      }.bind(this),
    });
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <form className="form-horizontal">
                  <div className="card card-info">
                    <div className="card-body">
                      {this.showNotification()}
                      <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item">
                          <a class="nav-link active font-weight-bold" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true"><i className="fa fa-file-excel" /> Upload Bukti Potong (xlsx)</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link font-weight-bold" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false"><i className="fa fa-file-pdf" /> Upload File Bukti Potong (pdf)</a>
                        </li>
                      </ul>
                      <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active p-3" id="home" role="tabpanel" aria-labelledby="home-tab">
                          {this.renderFormUpload()}
                          {this.renderTable()}
                        </div>
                        <div class="tab-pane fade p-3" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                          {this.renderFormUploadPDF()}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default MassUploadBupot